module.exports = __webpack_public_path__ + "static/media/psd.689e835a.png";